var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnvelope(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_239_2465)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_239_2465)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_2465)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_2465",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 22,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 9.99957H9.5V30.9996H30.5V9.99957Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_2465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3455 21.8213C28.5084 21.7195 28.7393 21.8292 28.7393 22.0213V26.6425C28.7393 28.0863 27.5668 29.25 26.1143 29.25H13.873C12.4205 29.25 11.248 28.0863 11.248 26.6425V22.0253C11.248 21.8343 11.486 21.7244 11.6505 21.8213L18.2043 25.7238C18.7555 26.0475 19.3768 26.2138 19.998 26.2138C20.6193 26.2138 21.2405 26.0475 21.7918 25.7238L28.3455 21.8213Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.749 19.5895C28.749 19.5895 28.749 19.6683 28.7402 19.7033L28.749 19.5895Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7593 17.1836L21.6343 12.3186C20.6718 11.5574 19.3243 11.5574 18.3618 12.3186L12.2368 17.1836C11.6068 17.6824 11.248 18.4261 11.248 19.2136V19.5899C11.248 20.1936 11.5718 20.7624 12.0968 21.0686L18.6505 24.9711C19.4818 25.4611 20.5143 25.4611 21.3455 24.9711L27.8993 21.0686C28.3893 20.7799 28.7043 20.2636 28.7393 19.7036V19.2136C28.7393 18.4261 28.3805 17.6824 27.7593 17.1836Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_239_2465",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_239_2465",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_2465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 21,
    fill: "white",
    transform: "translate(7 9.99989)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/icon-envelope.c09b541b562b38086f057ef1fa7738c1.svg";
export { ForwardRef as ReactComponent };